import { render, staticRenderFns } from "./remote-office-picker.vue?vue&type=template&id=4768f5f4&"
import script from "./remote-office-picker.vue?vue&type=script&lang=js&"
export * from "./remote-office-picker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports